import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@mantine/core";
import { InspectionDeviationResultDto } from "@/types";
import Accordion from "@/components/organisms/AccordionDrawer";
import Divider from "@/components/atoms/Divider";
import { useInspectionFormat } from "@/components/organisms/InspectionModal/useInspectionFormat";
import { PER_ORDER_UNIT_CODE } from "@/components/organisms/InspectionModal/utils";
import { DeviationDecision, DeviationHeader, InspectionPhotos, Row } from "./TabParts";

interface DeviationServicesAccordionProps {
  /** The inspection's deviations of kind SERVICE. */
  deviations: InspectionDeviationResultDto[];
  isBuyer: boolean;
}

/** The deviation services registered in the inspection: charged on top, at the contract's price. */
export default function DeviationServicesAccordion({ deviations, isBuyer }: DeviationServicesAccordionProps) {
  const { t } = useTranslation();
  const format = useInspectionFormat();

  return (
    <Accordion initiallyOpen title={t("inspections:deviations.servicesTitle")}>
      {deviations.map((deviation, index) => (
        <Fragment key={deviation.id}>
          {index > 0 && <Divider margin={false} />}
          <Grid p={20} data-testid="inspection-service-deviation">
            <DeviationHeader deviation={deviation} />
            <Row label={t("inspections:deviations.registeredNumber")}>
              {/* A per-order service is registered as 1, as in the modal. */}
              {deviation.unitCode === PER_ORDER_UNIT_CODE
                ? t("inspections:deviations.perOrder")
                : `${format.number(deviation.registeredNumber)} ${format.deviationUnit(deviation.unitCode)}`}
            </Row>
            <Row label={t("inspections:drawer.unitPrice")}>
              {format.unitPrice(deviation.unitPrice, deviation.currencyType, format.deviationUnit(deviation.unitCode))}
            </Row>
            <Row label={t("inspections:deviations.cost")}>{format.amount(deviation.cost, deviation.currencyType)}</Row>
            <Row label={t("inspections:photos.label")}>
              <InspectionPhotos photoIds={deviation.photoIds} />
            </Row>
            <DeviationDecision deviation={deviation} isBuyer={isBuyer} />
          </Grid>
        </Fragment>
      ))}
    </Accordion>
  );
}
